export default {
  headline: 'Bienvenue',
  welcomeText: process.env.VUE_APP_WELCOME_TEXT_EN ||
  'dans le système de gestion de l\'apprentissage d\'innovation mecom.'
}
